import styled, { css } from 'styled-components';

export const Wrapper = styled.div``;

export const Title = styled.div`
	font-size: 24px;
	line-height: 33px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.subtitle};
	margin-bottom: 16px;

	display: flex;
	justify-content: space-between;
	gap: 23px;

	@media (max-width: 992px) {
		cursor: pointer;
		font-size: 20px;
		line-height: 27px;
	}
`;

export const IconWrapper = styled.div<{ $isActive: boolean }>`
	width: 24px;
	height: 24px;
	display: none;

	svg {
		width: 100%;
		height: 100%;
		fill: ${({ theme }) => theme.colors.icon.chevron};
		transform: rotate(-90deg);

		${({ $isActive }) =>
			$isActive &&
			css`
				transform: rotate(90deg);
			`}
	}

	@media (max-width: 992px) {
		display: block;
	}
`;

export const Subtitle = styled.p<{ $isShown: boolean }>`
	font-size: 18px;
	line-height: 25px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};

	margin: 0;

	@media (max-width: 992px) {
		display: ${({ $isShown }) => ($isShown === true ? 'block' : 'none')};
		font-size: 14px;
		line-height: 19px;
	}
`;
